// 生产环境接口映射
const mapping = {
  '/ProxyAdmin': {
    target: process.env.VUE_APP_ADMIN_API,
    rewrite: {
      '/ProxyAdmin': ''
    }
  },
  "/v1": {
    target: process.env.VUE_APP_ADMIN_API,
  },
}

export function getDomain(url) {
  if (String(url).indexOf('/') === 0 && String(url).length > 1) {
    const key = url.split('/')[1] || ''
    return mapping[key]?.target ?? ''
  } else {
    return ''
  }
}
export function getBaseUrl(url) {
  if (String(url).indexOf('/') === 0 && String(url).length > 1) {
    const key = '/' + (url.split('/')[1] || '')
    const target = mapping[key]?.target ?? ''
    let path = url
    if (mapping[key]?.rewrite) {
      const rewriteKey = Object.keys(mapping[key]?.rewrite)
      const rewriteValue = Object.values(mapping[key]?.rewrite)
      path = String(url).replace(rewriteKey[0], rewriteValue[0])
    }
    return `${target}${path}`
  } else {
    return url
  }
}
